import { matchPath } from "react-router-dom"
import { Role } from "../../../mp-database"
import {
  DEFAULT_FILTER_BY_ROUTE,
  FILTER_ITEMS,
  FILTERS_BY_ROLE,
  FILTERS_BY_ROUTE,
  ORG_FILTERS,
  ORG_FILTERS_BY_ROLE,
  HIDDEN_FILTERS_FROM_FILTER_BAR_BY_ROUTE
} from "../../constants"
import { FilterTypeItem, UserFilterItem } from "../../types"

export const getFiltersByRoute = (
  currentLocation: string,
  routeValues: Record<string, string[]> = FILTERS_BY_ROUTE
) => {
  const viewName = Object.keys(routeValues).find(filterMatch =>
    matchPath(currentLocation, { path: filterMatch, exact: true })
  )

  return routeValues[viewName ?? "default"]
}

export const getFilters = (
  role: Role,
  currentLocation: string,
  filtersByRoute: Record<string, string[]>
): FilterTypeItem[] => {
  const filtersByView = getFiltersByRoute(currentLocation, filtersByRoute)
  const filtersByRole = FILTERS_BY_ROLE[role]
  // if we need in additional default filters in specific route
  const defaultFiltersByView = getFiltersByRoute(
    currentLocation,
    DEFAULT_FILTER_BY_ROUTE
  )
  // filters available for the user's role
  const availableByRole = ORG_FILTERS_BY_ROLE[role]

  // add filters to filters by role
  const combinedFilters = Array.from(
    new Set([
      ...(filtersByRole || []),
      /// Only include default org filters that are available for the role
      /// Non-org filters from DEFAULT_FILTER_BY_ROUTE are always included
      ...defaultFiltersByView.filter(
        i => !ORG_FILTERS.includes(i) || availableByRole.includes(i)
      )
    ])
  )

  // Check if we're on a mastery-curriculum route (dashboard or lessons/reports pages)
  const isMasteryCurriculumRoute = currentLocation.includes(
    "/teaching-tools/mastery-curriculum"
  )

  return FILTER_ITEMS.filter(filterItem => {
    // Exclude date filter for mastery-curriculum routes
    if (isMasteryCurriculumRoute && filterItem.key === "date") {
      return false
    }

    return (
      combinedFilters?.includes(filterItem.key) &&
      filtersByView.includes(filterItem.key)
    )
  })
}

export const getHiddenFilters = (args: {
  value: UserFilterItem[]
  currentLocation: string
}) => {
  const { value, currentLocation } = args

  // Hide content filter when a full program is selected in test filter (program-level, not subject-level)
  const testFilterValue = value.find(f => f.filter === "test")?.value ?? []
  const testFilterHasFullProgramSelected = testFilterValue.some(
    item => !item.includes("_")
  )

  const hiddenFilters = [
    ...(HIDDEN_FILTERS_FROM_FILTER_BAR_BY_ROUTE[currentLocation] || []),
    ...(testFilterHasFullProgramSelected ? ["content"] : [])
  ]

  return hiddenFilters
}
